import { Component, OnInit } from '@angular/core';

import { HeaderService } from '../../shared';

@Component({
  selector: 'app-equipments',
  templateUrl: './equipments.component.html',
  styleUrls: ['./equipments.component.scss']
})
export class EquipmentsComponent implements OnInit {

  constructor( private headerService: HeaderService ) { }

  ngOnInit() {
    this.headerService.changeTitle('Equipamentos');

    this.headerService.changeSubtitle('');

    this.headerService.changeDatePicker(false);
  }

}
